import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ExceptionService, SpinnerService, Message } from "../../blocks";
import { MessageService, HttpGeneralService } from "../../shared";
import { CONFIG } from "../../shared/config";

let usersUrl = CONFIG.baseUrls.users;
let appCodePermissopnsUrl = CONFIG.baseUrls.AppCodePermission;

export interface User {
  userID?: number;
  userName?: string;
  pacsPassword?: string;
  risFlag?: number;

  empId?: number;
  password?: string;
  pass?: string;
  admin?: boolean;
  defaultLang?: number;
  secondLang?: number;
  workEncrypLink?: boolean;
  active?: boolean;
  //  regDate: Date;
  //  regUser: number;
   updateDate?: Date;
  offset?: number;
  pageSize?: number;
  rowsCount?: number;
  defaultGroup: number;
  defaultBranch: number;
  securityLevel?: number;
  mappedUserName :string;
}

export interface UserAppCodePermission {
  serial: number;
  secLoginId: number;
  appCode: number;
  selected: true;
  inOutFlag:number;
}
export interface GroupAppCodePermission {
  serial: number;
  groupID: number;
  appCode: number;
  inOutFlag: boolean;
}

@Injectable()
export class UserService {
  constructor(private httpGeneralService: HttpGeneralService) {}
  searchUsers(searchObj: User) {
    return this.httpGeneralService.add(searchObj, `${usersUrl}/searchSp`);
  }
  getLinksBySecLoginss(secloginsId: number, appCodeGroup: number) {
    return this.httpGeneralService.getWith(
      `${appCodePermissopnsUrl}/${secloginsId}/${appCodeGroup}/SecLoadLinksBySecLoginsAndAppCodes`
    );
  }
  getUsers() {
    return this.httpGeneralService.getWith(`${usersUrl}`);
  }
  getUserAppCodePer(secLogins: number) {
    return this.httpGeneralService.getWith(
      `${appCodePermissopnsUrl}/${secLogins}/UserAppCodePer`
    );
  }
  getGroupAppCodePer(GroupID: number) {
    return this.httpGeneralService.getWith(
      `${appCodePermissopnsUrl}/${GroupID}/GroupAppCodePer`
    );
  }
  SecLoadLinksAppCodes(LinkId: number, seclogin: number) {
    return this.httpGeneralService.getWith(
      `${appCodePermissopnsUrl}/${LinkId}/SecLoadLinksAppCodes/${seclogin}`
    );
  }
  addUser(user: User) {
    return this.httpGeneralService.add<User>(user, usersUrl);
  }
  addUserAppCodePermission(userAppCodePermission: UserAppCodePermission[]) {
    return this.httpGeneralService.post(
      userAppCodePermission,
      `${appCodePermissopnsUrl}/PostUserAppCodePer`
    );
  }

  addGroupAppCodePermission(groupAppCodePermission: GroupAppCodePermission) {
    return this.httpGeneralService.add<GroupAppCodePermission>(
      groupAppCodePermission,
      `${appCodePermissopnsUrl}/PostGroupAppCodePer`
    );
  }

  getUser(id: number) {
    return this.httpGeneralService.get(id, usersUrl);
  }

  updateUser(user: User) {
    return this.httpGeneralService.update<User>(user.userID, user, usersUrl);
  }

  deleteUser(user: User) {
    return this.httpGeneralService.delete<number>(
      user.userID,
      `${usersUrl}/${user.userID}`
    );
  }
  deleteAppCode(appCode: any) {
    return this.httpGeneralService.delete<number>(
      appCode.serial,
      `${appCodePermissopnsUrl}`
    );
  }
  UserSettingCopy(userSetting: any) {
    return this.httpGeneralService.add(
      userSetting,
      `${appCodePermissopnsUrl}/UserSettingCopy`
    );
  }
}
